export async function removeItemFromStorage(localForage: LocalForage, key: string) {
    await localForage.ready();

    await localForage.removeItem(key);
}
